import { getActiveContentTab } from 'owa-tab-store';
import getSxSIdFromProjection from './getSxSIdFromProjection';

export default function getActiveSxSId(targetWindow: Window): string {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'string | null' is not assignable to type 'string'.
    // @ts-expect-error
    return targetWindow === window
        ? getActiveContentTab().sxsId
        : getSxSIdFromProjection(targetWindow);
}
